module.exports = __webpack_public_path__ + "img/Luiz_2.17a86486.png";